import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    status: "idle",
    m11ResearchStudyFoi: "",
    m11ResearchStudyResource: "",
    m11EligibilityCriteriaFoi: "",
    m11EligibilityCriteriaResource: "",
    m11ReportContainerFoi: "",
    m11ReportContainerResource: "",
    m11ReportSection01Foi: "",
    m11ReportSection01Resource: "",
    m11ReportSection02Foi: "",
    m11ReportSection02Resource: "",
    m11ReportSection03Foi: "",
    m11ReportSection03Resource: "",
    m11ReportSection04Foi: "",
    m11ReportSection04Resource: "",
    m11ReportSection05Foi: "",
    m11ReportSection05Resource: "",
    m11ReportSection06Foi: "",
    m11ReportSection06Resource: "",
    m11ReportSection07Foi: "",
    m11ReportSection07Resource: "",
    m11ReportSection08Foi: "",
    m11ReportSection08Resource: "",
    m11ReportSection09Foi: "",
    m11ReportSection09Resource: "",
    m11ReportSection10Foi: "",
    m11ReportSection10Resource: "",
    m11ReportSection11Foi: "",
    m11ReportSection11Resource: "",
    m11ReportSection12Foi: "",
    m11ReportSection12Resource: "",
    m11ReportSection13Foi: "",
    m11ReportSection13Resource: "",
    m11ReportSection14Foi: "",
    m11ReportSection14Resource: "",
};

const m11ReportAuthoringToolSlice = createAppSlice({
    name: "m11ReportAuthoringTool",
    initialState,
    reducers: create => ({
        m11ReportCollectionLoaded: create.reducer((state, action) => {
            state.m11ResearchStudyFoi = action.payload.m11ResearchStudyFoi
            state.m11ResearchStudyResource = action.payload.m11ResearchStudyResource
            state.m11EligibilityCriteriaFoi = action.payload.m11EligibilityCriteriaFoi
            state.m11EligibilityCriteriaResource = action.payload.m11EligibilityCriteriaResource
            state.m11ReportContainerFoi = action.payload.m11ReportContainerFoi
            state.m11ReportContainerResource = action.payload.m11ReportContainerResource
            state.m11ReportSection01Foi = action.payload.m11ReportSection01Foi
            state.m11ReportSection01Resource = action.payload.m11ReportSection01Resource
            state.m11ReportSection02Foi = action.payload.m11ReportSection02Foi
            state.m11ReportSection02Resource = action.payload.m11ReportSection02Resource
            state.m11ReportSection03Foi = action.payload.m11ReportSection03Foi
            state.m11ReportSection03Resource = action.payload.m11ReportSection03Resource
            state.m11ReportSection04Foi = action.payload.m11ReportSection04Foi
            state.m11ReportSection04Resource = action.payload.m11ReportSection04Resource
            state.m11ReportSection05Foi = action.payload.m11ReportSection05Foi
            state.m11ReportSection05Resource = action.payload.m11ReportSection05Resource
            state.m11ReportSection06Foi = action.payload.m11ReportSection06Foi
            state.m11ReportSection06Resource = action.payload.m11ReportSection06Resource
            state.m11ReportSection07Foi = action.payload.m11ReportSection07Foi
            state.m11ReportSection07Resource = action.payload.m11ReportSection07Resource
            state.m11ReportSection08Foi = action.payload.m11ReportSection08Foi
            state.m11ReportSection08Resource = action.payload.m11ReportSection08Resource
            state.m11ReportSection09Foi = action.payload.m11ReportSection09Foi
            state.m11ReportSection09Resource = action.payload.m11ReportSection09Resource
            state.m11ReportSection10Foi = action.payload.m11ReportSection10Foi
            state.m11ReportSection10Resource = action.payload.m11ReportSection10Resource
            state.m11ReportSection11Foi = action.payload.m11ReportSection11Foi
            state.m11ReportSection11Resource = action.payload.m11ReportSection11Resource
            state.m11ReportSection12Foi = action.payload.m11ReportSection12Foi
            state.m11ReportSection12Resource = action.payload.m11ReportSection12Resource
            state.m11ReportSection13Foi = action.payload.m11ReportSection13Foi
            state.m11ReportSection13Resource = action.payload.m11ReportSection13Resource
            state.m11ReportSection14Foi = action.payload.m11ReportSection14Foi
            state.m11ReportSection14Resource = action.payload.m11ReportSection14Resource
            state.status = "succeeded"
        }),
        m11ResearchStudyFoiChanged: create.reducer((state, action) => {
            state.m11ResearchStudyFoi = action.payload
        }),
        m11ResearchStudyResourceChanged: create.reducer((state, action) => {
            state.m11ResearchStudyResource = action.payload
        }),
        m11EligibilityCriteriaFoiChanged: create.reducer((state, action) => {
            state.m11EligibilityCriteriaFoi = action.payload
        }),
        m11EligibilityCriteriaResourceChanged: create.reducer((state, action) => {
            state.m11EligibilityCriteriaResource = action.payload
        }),
        m11ReportContainerFoiChanged: create.reducer((state, action) => {
            state.m11ReportContainerFoi = action.payload
        }),
        m11ReportContainerResourceChanged: create.reducer((state, action) => {
            state.m11ReportContainerResource = action.payload
        }),
        m11ReportSection01FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection01Foi = action.payload
        }),
        m11ReportSection01ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection01Resource = action.payload
        }),
        m11ReportSection02FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection02Foi = action.payload
        }),
        m11ReportSection02ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection02Resource = action.payload
        }),
        m11ReportSection03FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection03Foi = action.payload
        }),
        m11ReportSection03ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection03Resource = action.payload
        }),
        m11ReportSection04FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection04Foi = action.payload
        }),
        m11ReportSection04ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection04Resource = action.payload
        }),
        m11ReportSection05FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection05Foi = action.payload
        }),
        m11ReportSection05ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection05Resource = action.payload
        }),
        m11ReportSection06FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection06Foi = action.payload
        }),
        m11ReportSection06ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection06Resource = action.payload
        }),
        m11ReportSection07FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection07Foi = action.payload
        }),
        m11ReportSection07ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection07Resource = action.payload
        }),
        m11ReportSection08FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection08Foi = action.payload
        }),
        m11ReportSection08ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection08Resource = action.payload
        }),
        m11ReportSection09FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection09Foi = action.payload
        }),
        m11ReportSection09ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection09Resource = action.payload
        }),
        m11ReportSection10FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection10Foi = action.payload
        }),
        m11ReportSection10ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection10Resource = action.payload
        }),
        m11ReportSection11FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection11Foi = action.payload
        }),
        m11ReportSection11ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection11Resource = action.payload
        }),
        m11ReportSection12FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection12Foi = action.payload
        }),
        m11ReportSection12ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection12Resource = action.payload
        }),
        m11ReportSection13FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection13Foi = action.payload
        }),
        m11ReportSection13ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection13Resource = action.payload
        }),
        m11ReportSection14FoiChanged: create.reducer((state, action) => {
            state.m11ReportSection14Foi = action.payload
        }),
        m11ReportSection14ResourceChanged: create.reducer((state, action) => {
            state.m11ReportSection14Resource = action.payload
        })
    }),
    selectors: {
        selectM11ReportAuthoringToolStatus: m11ReportAuthoringTool => m11ReportAuthoringTool.status,
        selectM11ReportAuthoringToolError: m11ReportAuthoringTool => m11ReportAuthoringTool.error,
        selectM11ResearchStudyFoi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ResearchStudyFoi,
        selectM11ResearchStudyResource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ResearchStudyResource,
        selectM11EligibilityCriteriaFoi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11EligibilityCriteriaFoi,
        selectM11EligibilityCriteriaResource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11EligibilityCriteriaResource,
        selectM11ReportContainerFoi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportContainerFoi,
        selectM11ReportContainerResource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportContainerResource,
        selectM11ReportSection01Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection01Foi,
        selectM11ReportSection01Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection01Resource,
        selectM11ReportSection02Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection02Foi,
        selectM11ReportSection02Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection02Resource,
        selectM11ReportSection03Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection03Foi,
        selectM11ReportSection03Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection03Resource,
        selectM11ReportSection04Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection04Foi,
        selectM11ReportSection04Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection04Resource,
        selectM11ReportSection05Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection05Foi,
        selectM11ReportSection05Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection05Resource,
        selectM11ReportSection06Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection06Foi,
        selectM11ReportSection06Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection06Resource,
        selectM11ReportSection07Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection07Foi,
        selectM11ReportSection07Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection07Resource,
        selectM11ReportSection08Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection08Foi,
        selectM11ReportSection08Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection08Resource,
        selectM11ReportSection09Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection09Foi,
        selectM11ReportSection09Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection09Resource,
        selectM11ReportSection10Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection10Foi,
        selectM11ReportSection10Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection10Resource,
        selectM11ReportSection11Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection11Foi,
        selectM11ReportSection11Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection11Resource,
        selectM11ReportSection12Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection12Foi,
        selectM11ReportSection12Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection12Resource,
        selectM11ReportSection13Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection13Foi,
        selectM11ReportSection13Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection13Resource,
        selectM11ReportSection14Foi: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection14Foi,
        selectM11ReportSection14Resource: m11ReportAuthoringTool => m11ReportAuthoringTool.m11ReportSection14Resource
    }
});

export const {
    m11ReportCollectionLoaded,
    m11ResearchStudyFoiChanged,
    m11ResearchStudyResourceChanged,
    m11EligibilityCriteriaFoiChanged,
    m11EligibilityCriteriaResourceChanged,
    m11ReportContainerFoiChanged,
    m11ReportContainerResourceChanged,
    m11ReportSection01FoiChanged,
    m11ReportSection01ResourceChanged,
    m11ReportSection02FoiChanged,
    m11ReportSection02ResourceChanged,
    m11ReportSection03FoiChanged,
    m11ReportSection03ResourceChanged,
    m11ReportSection04FoiChanged,
    m11ReportSection04ResourceChanged,
    m11ReportSection05FoiChanged,
    m11ReportSection05ResourceChanged,
    m11ReportSection06FoiChanged,
    m11ReportSection06ResourceChanged,
    m11ReportSection07FoiChanged,
    m11ReportSection07ResourceChanged,
    m11ReportSection08FoiChanged,
    m11ReportSection08ResourceChanged,
    m11ReportSection09FoiChanged,
    m11ReportSection09ResourceChanged,
    m11ReportSection10FoiChanged,
    m11ReportSection10ResourceChanged,
    m11ReportSection11FoiChanged,
    m11ReportSection11ResourceChanged,
    m11ReportSection12FoiChanged,
    m11ReportSection12ResourceChanged,
    m11ReportSection13FoiChanged,
    m11ReportSection13ResourceChanged,
    m11ReportSection14FoiChanged,
    m11ReportSection14ResourceChanged
} = m11ReportAuthoringToolSlice.actions;

export const {
    selectM11ReportAuthoringToolStatus,
    selectM11ReportAuthoringToolError,
    selectM11ResearchStudyFoi,
    selectM11ResearchStudyResource,
    selectM11EligibilityCriteriaFoi,
    selectM11EligibilityCriteriaResource,
    selectM11ReportContainerFoi,
    selectM11ReportContainerResource,
    selectM11ReportSection01Foi,
    selectM11ReportSection01Resource,
    selectM11ReportSection02Foi,
    selectM11ReportSection02Resource,
    selectM11ReportSection03Foi,
    selectM11ReportSection03Resource,
    selectM11ReportSection04Foi,
    selectM11ReportSection04Resource,
    selectM11ReportSection05Foi,
    selectM11ReportSection05Resource,
    selectM11ReportSection06Foi,
    selectM11ReportSection06Resource,
    selectM11ReportSection07Foi,
    selectM11ReportSection07Resource,
    selectM11ReportSection08Foi,
    selectM11ReportSection08Resource,
    selectM11ReportSection09Foi,
    selectM11ReportSection09Resource,
    selectM11ReportSection10Foi,
    selectM11ReportSection10Resource,
    selectM11ReportSection11Foi,
    selectM11ReportSection11Resource,
    selectM11ReportSection12Foi,
    selectM11ReportSection12Resource,
    selectM11ReportSection13Foi,
    selectM11ReportSection13Resource,
    selectM11ReportSection14Foi,
    selectM11ReportSection14Resource
} = m11ReportAuthoringToolSlice.selectors;

export default m11ReportAuthoringToolSlice;